export default {
  headerContent: {
    title: 'Sompo Sigorta Yabancı Uyruklu Sağlık Sigortası Teklifi',
    slogan: "Yabancı Sağlık Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'YABANCI SAĞLIK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Sompo  Sigorta Yabancı Sağlık Sigortası',
    description: {
      title: 'Sompo  Sigorta Yabancı Sağlık Sigortası Nedir? ',
      content: [
        'Yabancı sağlık sigortası; Türkiye’de oturma izni almak isteyen veya eğitim görmek için gelen öğrenciler için yaptırılması zorunlu olan sigorta ürünüdür.',
        'Sompo Sigorta’nın sunmuş olduğu elit yabancı sağlık sigortası ile sağlığınızı güvence altına alabilirsiniz.'
      ]
    },
    subContent: {
      title: 'Sompo Sigorta Yabancı Sağlık Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph: 'Sompo Sigorta elit yabancı sağlık sigortası kapsamında yatarak ve ayakta tedavi teminatı sunulmaktadır.',
          subList: null
        },
        {
          paragraph: 'Yatarak Tedavi Teminatı Kapsamı;',
          subList: [
            'Ameliyat',
            'Anjiograf',
            'Hastane Oda - Refakatçi',
            'Hastane Tedavi',
            'Özellikli Tedavi ( Radyoterapi, Kemoterapi, Diyaliz )',
            'Yoğun Bakım'
          ]
        },
        {
          paragraph: 'Ayakta tedavi teminatı kapsamı;',
          subList: [
            'Doktor Muayene',
            'Fizik Tedavi ve Rehabilitasyon',
            'İlaç',
            'Küçük Müdahale',
            'Modern Teşhis',
            'Röntgen',
            'Tahlil'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Yabancı Sağlık Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Yabancı Sağlık Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Sompo  Sigorta Yabancı Sağlık Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
